import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Truck, Clock, Ban, Bot, AlertTriangle, Zap } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { PageHeader } from "../lib/ui";
import PendingView from "./desty/PendingView";
import ShippedView from "./desty/ShippedView";
import CancelView from "./desty/CancelView";
import AutoKeepView from "./desty/AutoKeepView";
import StockAlertView from "./desty/StockAlertView";
import KilatView from "./desty/KilatView";

const MODES = [
  { k: "pending", l: "Perlu Dikirim", i: Clock },
  { k: "shipped", l: "Terkirim", i: Truck },
  { k: "cancel", l: "Cancel", i: Ban },
  { k: "autokeep", l: "Auto Keep", i: Bot },
  { k: "kilat", l: "Pesanan Kilat", i: Zap },
  { k: "stock", l: "Stok Desty", i: AlertTriangle },
];

export default function DestyShipped() {
  const { can } = useAuth();
  const navigate = useNavigate();
  const write = can("warehouse_admin", "sales", "accounting");
  const [mode, setMode] = useState("autokeep");

  return (
    <div className="space-y-6">
      <PageHeader title="Desty — Sinkron Order" subtitle="Tarik order Shopee & Tiktok dari Desty: cek keep, Auto Keep untuk yang belum, dan konversi terkirim ke kasir.">
        <div className="inline-flex flex-wrap max-w-full rounded-lg border border-cocoa/20 overflow-hidden" data-testid="desty-mode-toggle">
          {MODES.map((m) => {
            const Icon = m.i;
            return (
              <button key={m.k} onClick={() => setMode(m.k)} data-testid={`desty-mode-${m.k}`}
                className={`flex items-center gap-1.5 px-3.5 py-2 text-sm transition-colors ${mode === m.k ? "bg-cocoa text-ivory" : "bg-white text-cocoa hover:bg-cocoa/5"}`}>
                <Icon className="w-4 h-4" /> {m.l}
              </button>
            );
          })}
        </div>
      </PageHeader>

      {mode === "pending" && <PendingView write={write} navigate={navigate} />}
      {mode === "shipped" && <ShippedView write={write} />}
      {mode === "cancel" && <CancelView write={write} />}
      {mode === "autokeep" && <AutoKeepView write={write} />}
      {mode === "kilat" && <KilatView write={write} />}
      {mode === "stock" && <StockAlertView write={write} />}
    </div>
  );
}
